module.exports = __webpack_public_path__ + "static/media/300dpi_Icon_Dark.495de69b.png";